<template>
  <div class="general-page">
    <h1>Login</h1>

    <p>Access your MyJobQuote account.</p>

    <div class="qform2022 full">
      <p
        v-if="first(errors)"
        class="notice error live"
      >
        <span class="icon-attention redicon" />
        {{ first(errors) }}
      </p>

      <form
        class="login-form"
        dusk="form"
        name="loginForm"
        @submit.prevent="post"
      >
        <div class="generic-inputs">
          <label>Email address</label>
          <input
            v-model="username"
            v-iosautofillfix
            dusk="email"
            type="email"
            name="email_address"
            placeholder="Email Address"
          >
          <router-link
            class="forgotpass"
            :to="{ name: 'sms-login' }"
          >
            Forgotten Email?
          </router-link>
        </div>

        <div class="generic-inputs">
          <label>Password</label>
          <input
            v-model="password"
            dusk="password"
            :type="[show_password ? 'text' : 'password']"
            placeholder="Password"
            name="password"
            autocomplete="current-password"
          >
          <router-link
            class="forgotpass"
            :to="{ name: 'forgotten-password', query: {email: username } }"
          >
            Forgotten Password?
          </router-link>
        </div>

        <div class="generic-inputs">
          <div
            class="terms-container checkbox terms-checkbox"
            style="margin-top: 0px"
            :class="{ 'active': show_password }"
            @click="toggleShowPassword"
          >
            <div class="checkbox" />
            <input
              type="hidden"
              name="show_password"
              value=""
            >
            <p>Show password</p>
          </div>
        </div>

        <div v-if="recaptchaFields.required">
          <vue-recaptcha
            ref="recaptcha"
            :sitekey="recaptchaKey"
            @verify="recaptchaCompleted"
          />
          <br>
        </div>

        <div
          v-if="loading"
          class="twobuttons"
        >
          <img
            src="/assets/images/loading.gif"
            style="width:200px;"
          >
        </div>
        <div
          v-else
          class="twobuttons"
        >
          <button
            dusk="submit"
            class="button"
            @click="post"
          >
            Login
          </button>
          <span>or</span>
          <router-link
            v-slot="{ navigate }"
            :to="{ name: 'magic-link', query: {email: username}}"
            custom
          >
            <button
              class="button clear"
              @click="navigate"
            >
              Email me a link to login
            </button>
          </router-link>
        </div>
      </form>
    </div>
    <br>
    <p class="last">
      <a
        href="/portal"
        class="normal-link"
      >Create an account</a> if you don't have one.
    </p>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import authComposable from "./AuthComposable.js";
import axios from '../../axios.js'
import {VueRecaptcha} from "vue-recaptcha";

export default {
    components: {
        VueRecaptcha
    },
    setup() {
        const loading = ref(false);
        const username = ref(null);
        const password = ref(null);
        const show_password = ref(false);
        const errors = ref([])
        const { recaptchaFields, resetCaptcha, recaptchaKey, first, recaptchaCompleted } = authComposable();

        const toggleShowPassword = () => {
            show_password.value = !show_password.value;
        };

        const post = async () => {
            await nextTick();
            loading.value = true;
            errors.value = [];

            axios({
                method: 'post',
                url: `/auth/login/username-password`,
                data: {
                    username: username.value,
                    password: password.value,
                    recaptcha_response: recaptchaFields.response
                }
            }).then(response => {
                if (response.data.redirect) {
                    window.location.href = response.data.redirect;
                }

                if (response.data.url) {
                    window.location = response.data.url;

                    setTimeout(() => {
                        loading.value = false;
                    }, 5000)

                } else if(response.data.errors) {
                    errors.value = response.data.errors;

                    if(errors.value.robot_check) {
                        recaptchaFields.required = true;
                    }

                    loading.value = false;
                } else {
                    loading.value = false;
                }
            }).catch(() => {
                errors.value = {general: ['Something went wrong; please try again later.']};
                loading.value = false;
            }).then(() => {
                resetCaptcha();
            });
        };

        const loadRecaptcha = async () => {
            await axios({
                method: 'get',
                url: `/auth/login/captcha`,
            }).then(response => {
                if (response.data.captcha) {
                    recaptchaFields.required = true;
                } else {
                    recaptchaFields.required = false;
                }
            }).catch(() => {
                recaptchaFields.required = false;
            });
        };


        onMounted(() => {
            loadRecaptcha();
        });

        return {
            loading,
            username,
            password,
            show_password,
            errors,
            recaptchaFields,
            post,
            loadRecaptcha,
            toggleShowPassword,
            recaptchaKey,
            first,
            recaptchaCompleted
        };
    }
};

</script>

<style>
.user-image {
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  flex-shrink: 0;
  margin: 0 5px;
}
</style>